// AddGroup.js
import PageContainer from "../PageContainer";
import { useData } from "../../../contexts/DataContext/DataContextt";
import { FeatureForm } from "./FeatureForm";
import { useState } from "react";
import { fetchFeatures, saveFeature } from "../../../services/featureService";
import { usePreload } from "../../../contexts/DataContext/PreloadContext";
import { saveIncludedFeature } from "../../../services/includedFeatureService";
import { featuresPageCache } from "../../../pages/cache/PageCache";
import { usePagedQuery } from "../../../contexts/hooks/usePagedQuery";

const AddFeature = () => {
  const { loading, language, setFeatures } = useData();
  const [saving, setSaving] = useState(false);
  const { showNotification } = usePreload();
  const { mutate, addOrDeleteIncludedFeatures } = usePagedQuery({
    fetchFunction: fetchFeatures,
    searchOn: "featureId",
    cache: featuresPageCache,
    language,
    deps: [language],
  });

  const onSave = async (updatedRow) => {
    if (!updatedRow.featureId || !updatedRow.featureType) {
      showNotification("Required fields: featureId, feature type", "error");
      return false;
    }

    try {
      setSaving(true);
      let newFeature = { ...updatedRow };
      newFeature = {
        ...newFeature,
        featureIncludedInClassCodes:
          newFeature.includedClasses
            ?.filter((f) => !f.deleted)
            .map((m) => m.id)
            .join("|") ?? "",
      };

      // Save|Delete included features

      if (newFeature.includedClasses?.length > 0) {
        const includedClasses = await addOrDeleteIncludedFeatures(newFeature);
        newFeature = { ...newFeature, includedClasses: includedClasses };
      }

      // Save feature
      await saveFeature(newFeature);

      showNotification(`new feature was added!`, "success");
      return true;
    } catch (e) {
      console.error(e);
      showNotification(
        `something went wrong when adding ${updatedRow?.featureId} feature.`,
        "error",
      );
      return false;
    } finally {
      setSaving(false);
    }
  };

  return (
    <PageContainer
      title="Create Feature"
      subtitle="Define properties, localized texts and class relations"
      breadcrumbs={[
        { title: "ETIM Feature", path: "/featuresnew" },
        { title: "New" },
      ]}
    >
      <FeatureForm
        onSave={onSave}
        props={{
          row: {},
          loading: loading,
          uploading: saving,
          showCancel: false,
          saveText: "Create",
          isUpdate: false,
        }}
      />
    </PageContainer>
  );
};

export default AddFeature;
